module.exports = __webpack_public_path__ + "img/Omobolade.198a7013.jpeg";